<template>
  <div class="prodetail">
    <van-nav-bar fixed title="商品详情页" left-arrow @click-left="$router.go(-1)" />

    <!-- 主图轮播 - 1:1 比例，取消自动播放 -->
    <div class="swipe-wrapper">
      <van-swipe @change="onChange">
        <van-swipe-item v-for="(item, index) in swipeImages" :key="index">
          <div class="swipe-item-inner">
            <img :src="item.external_url" alt="" />
          </div>
        </van-swipe-item>
        <div class="custom-indicator" slot="indicator">
          {{ current + 1 }} / {{ swipeImages.length }}
        </div>
      </van-swipe>
    </div>

    <div class="info">
      <div class="title">
        <div class="price">
          <span class="now">￥{{ detail.goods_price_min }}</span>
          <span class="oldprice">￥{{ detail.goods_price_max }}</span>
        </div>
        <div class="sellcount">已售{{ detail.goods_sales }}件</div>
      </div>
      <div class="msg text-ellipsis-2"> {{ detail.goods_name }} </div>

      <!-- C2C：展示该商品所属店铺，点击可进入店铺客服 -->
      <div class="shop-bar" v-if="detail.shop_name" @click="contactService">
        <span class="shop-icon">🏪</span>
        <span class="shop-name">{{ detail.shop_name }}</span>
        <span class="shop-tag" v-if="detail.shop_is_official === 1">官方自营</span>
        <span class="shop-enter">进入店铺咨询 <van-icon name="arrow" /></span>
      </div>

      <div class="service">
        <div class="left-words">
          <span><van-icon name="passed" />七天无理由退货</span>
          <span><van-icon name="passed" />48小时发货</span>
        </div>
        <div class="right-icon"><van-icon name="arrow" /></div>
      </div>

      <!-- 抢购动态：刚刚有哪些用户在抢购（后端按近 24 小时下单记录生成，昵称已脱敏） -->
      <div class="rush" v-if="rushLogs.length">
        <div class="rush-head">
          <span class="rush-dot"></span>
          <span class="rush-title">抢购动态</span>
          <span class="rush-sub" v-if="rushRecentCount > 0">近24小时 {{ rushRecentCount }} 人在抢</span>
        </div>
        <div class="rush-list">
          <div class="rush-item" v-for="item in rushLogs" :key="item.user_id">
            <img :src="item.avatar || localavatar" alt="">
            <span class="rush-name">{{ item.nickname }}</span>
            <span class="rush-text">抢购了 {{ item.num }} 件</span>
            <span class="rush-time">{{ item.time_text }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="comment">
      <div class="comment-title">
        <div class="left">商品评价 ({{ comments.total }}条)</div>
        <div class="right" @click="goCommentList">查看更多 <van-icon name="arrow" /></div>
      </div>
      <div class="comment-list">
        <div class="comment-item" v-for="item in comments.list" :key="item.comment_id">
          <div class="top">
            <img :src="item.user.avatar_url || localavatar" alt="" />
            <div class="name">{{ item.user.nick_name }}</div>
            <van-rate :size="16" :value="item.score" readonly />
          </div>
          <div class="content">{{ item.content }}</div>
          <div class="time">{{ item.create_time }}</div>
        </div>
      </div>
    </div>

    <!-- 详情图 - 支持方图和长图自适应 -->
    <div class="desc-wrapper">
      <div class="desc" v-html="detail.goods_desc"></div>
    </div>

    <div class="footer">
      <div class="icon-cart" @click="$router.push('/cart')">
        <van-icon name="cart-o" /><span>购物车</span>
        <span class="num" v-if="cartTotalNum > 0">{{ cartTotalNum }}</span>
      </div>
      <div class="icon-home" @click="$router.push('/home')">
        <van-icon name="home-o" /><span>首页</span>
      </div>
      <div class="icon-service" @click="contactService">
        <van-icon name="service-o" /><span>客服</span>
      </div>
      <div class="btn-add" @click="addToCart">加入购物车</div>
      <div class="btn-buy" @click="buyNow">立即购买</div>
    </div>

    <!-- 规格选择弹窗 -->
    <van-popup v-model="showSkuPopup" round position="bottom" class="sku-popup" :close-on-click-overlay="true">
      <div class="sku-popup-body">
        <div class="sku-popup-top">
          <img
            :src="selectedSkuObj && selectedSkuObj.image ? selectedSkuObj.image : detail.goods_image"
            alt=""
            class="sku-popup-img"
          />
          <div class="sku-popup-info">
            <div class="sku-popup-price">￥{{ skuPopupPrice }}</div>
            <div class="sku-popup-stock" v-if="selectedSkuObj">库存 {{ selectedSkuObj.stock }} 件</div>
            <div class="sku-popup-name text-ellipsis-2">{{ detail.goods_name }}</div>
          </div>
          <van-icon name="cross" class="sku-popup-close" @click="showSkuPopup = false" />
        </div>
        <div class="sku-popup-section">
          <div class="sku-popup-title">选择规格</div>
          <div class="sku-options">
            <div
              class="sku-option"
              v-for="sku in skuList"
              :key="sku.sku_id"
              :class="{ active: selectedSkuId === sku.sku_id, disabled: sku.stock <= 0 }"
              @click="selectSku(sku)"
            >
              <span class="sku-option-name">{{ sku.spec_name }}</span>
              <span class="sku-option-price">￥{{ sku.price }}</span>
              <span class="sku-option-stock" v-if="sku.stock <= 0">无货</span>
            </div>
          </div>
        </div>
        <div class="sku-popup-btn" :class="{ disabled: !selectedSkuId }" @click="confirmSelectSku">
          {{ buyType === 'buy' ? '立即购买' : '加入购物车' }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getGoodsDetailApi, getGoodsCommentsApi, getGoodsRushLogsApi, recordGoodsViewApi } from '@/api/product'
import { addGoodToCartApi } from '@/api/cart'
import CountBox from '@/components/CountBox.vue'
import { setSeo } from '@/utils/seo'
import { Toast } from 'vant'

export default {
  name: 'ProDetail',
  components: { CountBox },
  data () {
    return {
      detail: {},
      swipeImages: [],
      comments: { total: 0, list: [] },
      // 抢购动态（近 24 小时下单抢购该商品的用户列表）
      rushLogs: [],
      // 近 24 小时抢购人数
      rushRecentCount: 0,
      // 抢购动态轮询定时器
      rushTimer: null,
      current: 0,
      localavatar: require('@/assets/default-avatar.svg'),
      // 规格选择弹窗
      showSkuPopup: false,
      selectedSkuId: 0,
      buyType: 'cart'
    }
  },
  computed: {
    cartTotalNum () { return this.$store.getters['cart/cartGoodsTotal'] },
    token () { return this.$store.getters.token },
    // 商品规格列表（无规格则为空数组）
    skuList () { return (this.detail.skuList || []).filter(sku => sku.price > 0) },
    selectedSkuObj () {
      if (!this.selectedSkuId) return null
      return this.skuList.find(sku => sku.sku_id === this.selectedSkuId) || null
    },
    // 规格弹窗展示价格：优先规格价，无规格时显示商品最低价
    skuPopupPrice () {
      return this.selectedSkuObj ? this.selectedSkuObj.price : this.detail.goods_price_min
    }
  },
  created () {
    this.getDetail()
    this.getComments()
    this.recordView()
    this.getRushLogs()
    // 抢购动态 30 秒轮询刷新，页面销毁时清理定时器
    this.rushTimer = setInterval(() => {
      this.getRushLogs()
    }, 30000)
  },
  beforeDestroy () {
    if (this.rushTimer) {
      clearInterval(this.rushTimer)
      this.rushTimer = null
    }
  },
  methods: {
    async getDetail () {
      const goodsId = this.$route.params.id
      const { data } = await getGoodsDetailApi(goodsId)
      this.detail = data
      this.swipeImages = data.swipeList
      // SEO：商品详情页按商品数据设置标题 / 描述 / canonical（搜索引擎渲染后即可识别页面主题）
      this.applySeo(data)
    },
    // 商品页 SEO：标题=商品名，描述取副标题或截取详情文本
    applySeo (goods) {
      if (!goods || !goods.goods_name) return
      const price = Number(goods.goods_price_min) > 0 ? '参考价 ¥' + goods.goods_price_min + '，' : ''
      const desc = goods.goods_subtitle
        ? goods.goods_subtitle
        : String(goods.goods_desc || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 100)
      setSeo({
        title: goods.goods_name,
        description: (goods.goods_name + '：' + price + desc).slice(0, 120),
        keywords: [goods.goods_name, '欢乐购商城', '网上购物', '正品保障'].join(','),
        path: '/prodetail/' + this.$route.params.id
      })
    },
    async getComments () {
      const goodsId = this.$route.params.id
      const { data } = await getGoodsCommentsApi({ goodsId, limit: 5 })
      this.comments = data
    },
    // 查看更多评论 - 跳转到评论列表页
    goCommentList () {
      this.$router.push({
        path: '/commentlist',
        query: { goodsId: this.$route.params.id }
      })
    },
    onChange (index) { this.current = index },

    // 记录商品浏览（后台数据分析用，失败不影响页面）
    recordView () {
      const goodsId = this.$route.params.id
      if (!goodsId) return
      recordGoodsViewApi(goodsId)
        .catch((e) => {
          console.error('记录商品浏览失败', e)
        })
    },

    // 抢购动态：刚刚有哪些用户下单抢购了该商品（昵称后端已脱敏）
    async getRushLogs () {
      const goodsId = this.$route.params.id
      if (!goodsId) return
      try {
        const { data } = await getGoodsRushLogsApi(goodsId, 10)
        this.rushLogs = (data && data.list) || []
        this.rushRecentCount = (data && data.recent_count) || 0
      } catch (e) {
        // 抢购动态属于增强信息，获取失败不影响详情页其它内容
        console.error('获取抢购动态失败', e)
      }
    },

    // 加入购物车 - 有规格时先弹出规格选择
    async addToCart () {
      // 未登录时提示并跳转登录页
      if (!this.token) {
        Toast('请先登录')
        this.$router.push('/login')
        return
      }

      // 有多规格时弹出选择
      if (this.skuList.length > 0) {
        this.openSkuPopup('cart')
        return
      }

      const goodsId = this.$route.params.id
      const stock = Number(this.detail.goods_stock)
      
      // 默认购买数量为1
      const buyNum = 1
      
      // 校验库存
      if (stock > 0 && buyNum > stock) {
        Toast(`库存不足，当前仅剩 ${stock} 件`)
        return
      }

      try {
        await addGoodToCartApi({ goodsId, goodsNum: buyNum, goodsSkuId: 0 })
        Toast('加入购物车成功')
        // 刷新购物车数据
        await this.$store.dispatch('cart/getCartList')
      } catch (err) {
        if (err === '请先登录' || err === '登录已失效，请重新登录') {
          Toast('请先登录')
          this.$router.push('/login')
          return
        }
        Toast(typeof err === 'string' ? err : '加入购物车失败，请稍后重试')
      }
    },

    // 打开规格选择弹窗
    openSkuPopup (type) {
      // 默认选中第一个有货的规格
      const available = this.skuList.find(sku => sku.stock > 0)
      this.selectedSkuId = available ? available.sku_id : 0
      this.buyType = type
      this.showSkuPopup = true
    },

    // 选择规格
    selectSku (sku) {
      if (sku.stock <= 0) return
      this.selectedSkuId = sku.sku_id
    },

    // 确认规格选择
    async confirmSelectSku () {
      if (!this.selectedSkuId) {
        Toast('请选择规格')
        return
      }
      const sku = this.selectedSkuObj
      if (!sku) return
      if (this.buyType === 'buy') {
        // 立即购买
        this.$router.push({
          path: '/pay',
          query: {
            mode: 'buy',
            goodsId: this.$route.params.id,
            goodsNum: 1,
            goodsSkuId: this.selectedSkuId
          }
        })
        return
      }
      // 加入购物车
      if (!this.token) {
        Toast('请先登录')
        this.$router.push('/login')
        return
      }
      if (sku.stock <= 0) {
        Toast('该规格暂无库存')
        return
      }
      try {
        await addGoodToCartApi({ goodsId: this.$route.params.id, goodsNum: 1, goodsSkuId: this.selectedSkuId })
        Toast('加入购物车成功')
        this.showSkuPopup = false
        await this.$store.dispatch('cart/getCartList')
      } catch (err) {
        if (err === '请先登录' || err === '登录已失效，请重新登录') {
          Toast('请先登录')
          this.$router.push('/login')
          return
        }
        Toast(typeof err === 'string' ? err : '加入购物车失败，请稍后重试')
      }
    },

    // 联系客服（C2C：进入该商品所属商家的店铺客服会话）
    contactService () {
      // 未登录时提示并跳转登录页
      if (!this.token) {
        Toast('请先登录')
        this.$router.push('/login')
        return
      }
      const detail = this.detail || {}
      const merchantId = detail.merchant_id || 0
      this.$router.push({
        path: '/chat',
        query: { merchantId: String(merchantId), shopName: detail.shop_name || '' }
      })
    },

    // 立即购买 - 直接跳转到提交订单页面
    buyNow () {
      // 未登录时提示并跳转登录页
      if (!this.token) {
        Toast('请先登录')
        this.$router.push('/login')
        return
      }

      // 有多规格时弹出选择
      if (this.skuList.length > 0) {
        this.openSkuPopup('buy')
        return
      }

      const goodsId = this.$route.params.id
      const stock = Number(this.detail.goods_stock)
      
      // 校验库存
      if (stock <= 0) {
        Toast('商品库存不足')
        return
      }

      // 直接跳转到支付页面，默认数量为1
      this.$router.push({ 
        path: '/pay', 
        query: { 
          mode: 'buy', 
          goodsId, 
          goodsNum: 1, 
          goodsSkuId: 0 
        } 
      })
    }
  }
}
</script>

<style lang="less" scoped>
.prodetail {
  padding-top: 46px;
  padding-bottom: 70px;

  ::v-deep .van-icon-arrow-left {
    color: #333;
  }

  // ============ 主图轮播 - 1:1 比例 ============
  .swipe-wrapper {
    width: 100%;
    aspect-ratio: 1 / 1;
    background: #f5f5f5;
    overflow: hidden;

    .van-swipe {
      width: 100%;
      height: 100%;
    }

    .van-swipe-item {
      width: 100%;
      height: 100%;
    }

    .swipe-item-inner {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .custom-indicator {
      position: absolute;
      right: 10px;
      bottom: 10px;
      padding: 4px 12px;
      font-size: 12px;
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 12px;
      z-index: 10;
    }
  }

  // ============ 详情图 - 支持方图和长图 ============
  .desc-wrapper {
    width: 100%;
    overflow: hidden;
    background: #fff;

    .desc {
      width: 100%;
      overflow: hidden;

      ::v-deep {
        img {
          display: block;
          width: 100% !important;
          height: auto !important;
          max-width: 100% !important;
          object-fit: contain;
        }

        * {
          max-width: 100% !important;
        }

        p,
        div,
        section {
          max-width: 100% !important;
          overflow: hidden !important;
        }
      }
    }
  }

  .info {
    padding: 10px;
    .title {
      display: flex;
      justify-content: space-between;
      .now {
        color: #ff6b35;
        font-size: 20px;
      }
      .oldprice {
        color: #959595;
        font-size: 16px;
        text-decoration: line-through;
        margin-left: 5px;
      }
      .sellcount {
        color: #959595;
        font-size: 16px;
        position: relative;
        top: 4px;
      }
    }
    .msg {
      font-size: 16px;
      line-height: 24px;
      margin-top: 5px;
    }
    .shop-bar {
      display: flex;
      align-items: center;
      margin-top: 8px;
      padding: 8px 10px;
      background-color: #fff8f3;
      border-radius: 6px;
      font-size: 13px;
      cursor: pointer;

      .shop-icon { margin-right: 6px; }
      .shop-name { color: #333; font-weight: 600; }

      .shop-tag {
        margin-left: 6px;
        font-size: 11px;
        color: #ff6b35;
        border: 1px solid #ffd2b0;
        border-radius: 4px;
        padding: 0 4px;
      }

      .shop-enter {
        margin-left: auto;
        color: #ff6b35;
        display: flex;
        align-items: center;
      }
    }

    .service {
      display: flex;
      justify-content: space-between;
      line-height: 40px;
      margin-top: 10px;
      font-size: 16px;
      background-color: #fafafa;
      .left-words span {
        margin-right: 10px;
      }
      .left-words .van-icon {
        margin-right: 4px;
        color: #ff6b35;
      }
    }

    // 抢购动态（刚刚有哪些用户在抢购）
    .rush {
      margin-top: 10px;
      padding: 10px;
      background: linear-gradient(90deg, #fff8f3, #fff);
      border-radius: 8px;

      .rush-head {
        display: flex;
        align-items: center;
        font-size: 13px;

        .rush-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #ff6b35;
          margin-right: 6px;
        }

        .rush-title {
          font-weight: 600;
          color: #333;
        }

        .rush-sub {
          margin-left: auto;
          font-size: 12px;
          color: #ff6b35;
        }
      }

      .rush-list {
        margin-top: 6px;
        max-height: 112px;
        overflow-y: auto;
      }

      .rush-item {
        display: flex;
        align-items: center;
        line-height: 26px;
        font-size: 12px;
        color: #666;

        img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          margin-right: 6px;
          flex-shrink: 0;
        }

        .rush-name {
          color: #333;
          margin-right: 6px;
          max-width: 90px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .rush-text {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .rush-time {
          color: #999;
          flex-shrink: 0;
        }
      }
    }
  }

  .comment {
    padding: 10px;
    .comment-title {
      display: flex;
      justify-content: space-between;
      .right {
        color: #959595;
      }
    }
    .comment-item {
      font-size: 16px;
      line-height: 30px;
      .top {
        height: 30px;
        display: flex;
        align-items: center;
        margin-top: 20px;
        img {
          width: 20px;
          height: 20px;
        }
        .name {
          margin: 0 10px;
        }
      }
      .time {
        color: #999;
      }
    }
  }

  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 55px;
    background-color: #fff;
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .icon-cart,
    .icon-home,
    .icon-service {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      padding: 0 6px;
      .van-icon {
        font-size: 24px;
      }
    }
    .icon-cart {
      position: relative;
      .num {
        z-index: 999;
        position: absolute;
        top: -2px;
        right: 0;
        min-width: 16px;
        padding: 0 4px;
        color: #fff;
        text-align: center;
        background-color: #ff6b35;
        border-radius: 50%;
        font-size: 10px;
        line-height: 16px;
      }
    }
    .btn-add,
    .btn-buy {
      height: 36px;
      line-height: 36px;
      flex: 1;
      max-width: 110px;
      border-radius: 18px;
      background-color: #ffa900;
      text-align: center;
      color: #fff;
      font-size: 14px;
    }
    .btn-buy {
      background-color: #fe5630;
    }
  }

  // ============ 规格选择弹窗 ============
  .sku-popup {
    .sku-popup-body {
      padding: 16px;
      padding-bottom: calc(16px + env(safe-area-inset-bottom));
    }
    .sku-popup-top {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      position: relative;
      .sku-popup-img {
        width: 88px;
        height: 88px;
        border-radius: 8px;
        object-fit: cover;
        background: #f7f8fa;
        flex-shrink: 0;
      }
      .sku-popup-info {
        flex: 1;
        .sku-popup-price { color: #fe5630; font-size: 18px; font-weight: 700; }
        .sku-popup-stock { font-size: 12px; color: #999; margin-top: 4px; }
        .sku-popup-name { font-size: 13px; color: #333; margin-top: 6px; line-height: 1.4; }
      }
      .sku-popup-close {
        font-size: 20px;
        color: #999;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
    .sku-popup-section {
      margin-top: 16px;
      .sku-popup-title { font-size: 14px; font-weight: 600; color: #333; margin-bottom: 10px; }
      .sku-options {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .sku-option {
          min-width: 90px;
          padding: 8px 14px;
          border: 1px solid #ddd;
          border-radius: 8px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s;
          background: #fff;
          &.active {
            border-color: #fe5630;
            background: #fff5f2;
            .sku-option-name { color: #fe5630; }
          }
          &.disabled {
            opacity: 0.45;
            cursor: not-allowed;
            background: #f7f8fa;
          }
          .sku-option-name { display: block; font-size: 13px; color: #333; }
          .sku-option-price { display: block; font-size: 12px; color: #fe5630; margin-top: 2px; }
          .sku-option-stock { display: block; font-size: 11px; color: #999; margin-top: 2px; }
        }
      }
    }
    .sku-popup-btn {
      margin-top: 18px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border-radius: 22px;
      background: linear-gradient(90deg, #fe5630, #ff8c42);
      color: #fff;
      font-size: 15px;
      font-weight: 600;
      cursor: pointer;
      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>